import { createBrowserRouter } from 'react-router';
import { LoginChooser } from '@/features/auth/LoginChooser';
import { LoginPage } from '@/features/auth/LoginPage';
import { InternalLayout } from '@/features/internal/InternalLayout';
import { internalRoutes } from '@/features/internal/routes';
import { OwnerLayout } from '@/features/owner/OwnerLayout';
import { ownerRoutes } from '@/features/owner/routes';
import { ParentLayout } from '@/features/parent/ParentLayout';
import { parentRoutes } from '@/features/parent/routes';
import { StudentLayout } from '@/features/student/StudentLayout';
import { studentRoutes } from '@/features/student/routes';
import { NotFoundPage, RootRedirect, RouteError } from './system-pages';

/**
 * Four apps, one client. Which one you see is decided by your role at sign-in:
 *   /app       center owners, managers and their staff
 *   /student   students
 *   /parent    parents and guardians
 *   /internal  the TCM team
 */
export const router = createBrowserRouter([
  { path: '/', element: <RootRedirect /> },
  { path: '/login', element: <LoginChooser /> },
  { path: '/login/owner', element: <LoginPage audience="owner" /> },
  { path: '/login/student', element: <LoginPage audience="student" /> },
  { path: '/login/parent', element: <LoginPage audience="parent" /> },
  { path: '/login/team', element: <LoginPage audience="internal" /> },
  { path: '/app', element: <OwnerLayout />, errorElement: <RouteError />, children: ownerRoutes },
  { path: '/student', element: <StudentLayout />, errorElement: <RouteError />, children: studentRoutes },
  { path: '/parent', element: <ParentLayout />, errorElement: <RouteError />, children: parentRoutes },
  { path: '/internal', element: <InternalLayout />, errorElement: <RouteError />, children: internalRoutes },
  { path: '*', element: <NotFoundPage /> },
]);
